import InfiniteScrollList from "../../../../../common/infinite-scroll-list";
import ConfigService from "../../../../../../services/ConfigService";
import JWTClient from "../../../../../../services/JWTClient";
import NotificationListItem from "../notification-list-item";
import NotificationService from "../../../../../../services/NotificationService";
import ModuleInfoProvider from "../../../../../../services/ModuleInfoProvider";

export default class NotificationInfiniteScrollList extends InfiniteScrollList {
    emptyStateMessage = 'notification.list.empty';
    notificationStoreDomain = '';
    observer = null;
    visibleIds = {};
    visualizedIds = {};
    visualizationCheckInterval = null;

    constructor(props) {
        super(props);
        this.notificationStoreDomain = ModuleInfoProvider.getModuleWebServiceUrl('notification-store');
    }

    static defaultProps = {
        onVisualized: () => {},
        freeze: true
    };

    componentDidMount() {
        this.getNext();
        NotificationService.observable.subscribe(this.getPrev);
        this.visualizationCheckInterval = setInterval(() => this.markNotificationsAsVisualized(), 1000);
    }

    componentWillUnmount() {
        NotificationService.observable.unsubscribe(this.getPrev);
        if (this.observer) this.observer.disconnect();
        clearInterval(this.visualizationCheckInterval);
    }

    componentDidUpdate(previousProps, previousState, previousContext) {
        const scrollEl = this.scrollRef.current.parentElement;
        const children = scrollEl.querySelectorAll('.obsItem');

        if (!this.observer) {
            let options = {
                root: scrollEl,
                rootMargin: '0px',
                threshold: 0.5
            };
            this.observer = new IntersectionObserver(this.onIntersection, options);
        }

        this.observer.disconnect();

        for (let child of children) {
            this.observer.observe(child);
        }
    }

    renderItem = (item) => (
        <div className="obsItem" data-id={item.visualized ? 0 : item.id}>
            <NotificationListItem notification={item}/>
        </div>
    );

    getPrevRequest = () => {
        const list = this.state.list;
        const boundId = list.length ? list[0].id : 0;
        return JWTClient.fetch(this.notificationStoreDomain + '/api/v1/notification?limit=100&sortBy=-id&afterId=' + boundId);
    };

    getNextRequest = () => {
        const list = this.state.list;
        const boundId = list.length ? list[list.length - 1].id : 100000000;
        return JWTClient.fetch(this.notificationStoreDomain + '/api/v1/notification?limit=10&sortBy=-id&beforeId=' + boundId);
    };

    onIntersection = (intersections) => {
        if (this.props.freeze || !intersections) return;
        for(let intersection of intersections) {
            if (intersection.isIntersecting && parseInt(intersection.target.dataset.id) > 0) {
                this.visibleIds[intersection.target.dataset.id] = true;
            }
        }
    };

    markNotificationsAsVisualized() {
        const visibleIds = Object.keys(this.visibleIds);
        if (!visibleIds.length) return;

        const ids = visibleIds.filter(id => Object.keys(this.visualizedIds).indexOf(id) < 0).map(i => parseInt(i));
        if (!ids.length) return;

        const domain = this.notificationStoreDomain;
        JWTClient.fetch(domain + '/api/v1/notification/visualized', {
            method: 'POST',
            headers: {'Content-Type': 'application/json'},
            body: JSON.stringify({
                data: ids
            })
        }).then(() => {
            this.props.onVisualized();
            for (let id of ids) {
                this.visualizedIds[id] = true;
            }
            for (let item of this.state.list) {
                if (this.visualizedIds.hasOwnProperty(item.id)) {
                    item.visualized = true;
                }
            }
            this.forceUpdate();
        });
    }
}



// WEBPACK FOOTER //
// ./components/sections/personal-area/sections/notification/notification-infinite-scroll-list/index.js